// packages/shared/src/schemas/user.ts
import { z } from 'zod'
import { optionalEmail } from './optional-email.js'

export const RoleEnum = z.enum(['customer', 'admin', 'superadmin'])

export const UserSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string().email().nullable(),
  phone: z.string().nullable(),
  role: RoleEnum,
  isActive: z.boolean(),
  lastLoginAt: z.string().nullable(),
  createdAt: z.string(),
})

export const CustomerRegisterInput = z.object({
  name: z.string().min(1, 'Name is required').max(100).trim(),
  phone: z.string().regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number'),
  email: optionalEmail,
  password: z.string().min(8, 'Password must be at least 8 characters').max(100),
})

export const CustomerLoginInput = z.object({
  phone: z.string().regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number'),
  password: z.string().min(1, 'Password is required'),
})

export const AdminLoginInput = z.object({
  email: z.string().email(),
  password: z.string().min(8, 'Password must be at least 8 characters'),
})

export const CreateAdminInput = z.object({
  name: z.string().min(1).max(100).trim(),
  email: z.string().email(),
  password: z.string().min(8).max(100),
  role: z.enum(['admin', 'superadmin']).default('admin'),
})

export type User = z.infer<typeof UserSchema>
export type CustomerRegisterInput = z.infer<typeof CustomerRegisterInput>
export type CustomerLoginInput = z.infer<typeof CustomerLoginInput>
export type AdminLoginInput = z.infer<typeof AdminLoginInput>
